export class DateUtils {
  static readonly oneDayDiff = 1000 * 60 * 60 * 24;

  public static parseDate(date: string): Date | undefined {
    return date ? new Date(date) : undefined;
  }

  /*
    Extracts the time in 24H format from a date
  */
  public static getTime(date: Date): string {
    return date
      ? `${new Date(date).getHours()}:${new Date(date).getMinutes()}`
      : '';
  }

  /*
    Adds the time to the date
    Time must be in 24H format '20:00'
  */ 
  public static setTime(date: Date, time: string, endOfDay: boolean) {
    if (!date) {
      return;
    }
    if (!time || time === '') {
      time = endOfDay ? '23:59' : '0:0';
    }

    const sp = time.split(':');
    if (sp.length === 2) {
      const hours = Number(sp[0]);
      const minutes = Number(sp[1]);
      date.setHours(hours);
      date.setMinutes(minutes);
    }

    date.setSeconds(0);
    date.setMilliseconds(0);

    return date;
  }

  static addDays(d: Date, days: number) {
    return new Date(d.getTime() + days * DateUtils.oneDayDiff);
  }

  static diffDays(startDate: Date, endDate: Date) {
    return (endDate.getTime() - startDate.getTime()) / DateUtils.oneDayDiff;
  }


  static displayDuration(duration: string) {
    if (!duration) return 'Imediatley';
    let parts = duration.split(':');
    parts = parts.reverse();

    const mm = parts.length > 0 && parseInt(parts[0]);
    const hh = parts.length > 1 && parseInt(parts[1]);
    const dd = parts.length > 2 && parseInt(parts[2]);

    if (dd == 0 && hh == 0 && mm == 0) return 'Imediatley';

    return `${dd > 0 ? dd + ' days' : ''} ${hh > 0 ? hh + ' hours' : ''} ${mm > 0 ? mm + ' mins' : ''}`;
  }

  static displayCsDuration(ts: string) {
    if (!ts) return '';

    if (ts.length < 8)
      ts+= ':0';

    // d.hh.mm:ss <=> d:hh:mm:ss
    let days = 0;
    if (ts.indexOf('.') > 0) {
      days = parseInt(ts.split('.')[0]);
      ts = ts.split('.')[1];
    }
    if (ts.split(':').length === 4) {
      days = parseInt(ts.split(':')[0]);
      ts = ts.substring(ts.indexOf(':') + 1, ts.length);
    }

    let parts = ts.split(':');
    parts = parts.reverse();

    const ss = parts.length > 0 && parseInt(parts[0]);
    const mm = parts.length > 1 && parseInt(parts[1]) || 0;
    const hh = parts.length > 2 && parseInt(parts[2]) || 0;

    if (days === 0 && ss === 0 && mm === 0 && hh === 0) return '';

    return `${days > 0 ? days + ' days' : ''} ${hh > 0 ? hh + ' hours' : ''} ${mm > 0 ? mm + ' mins' : ''} ${ss > 0 ? ss + ' sec' : ''}`;
  }

  static isValidTimestamp(ts: string) {
    if (!ts || ts.length < 8) return false;

    // d.hh.mm:ss <=> d:hh:mm:ss
    let dd = 0;
    if (ts.indexOf('.') > 0) {
      dd = parseInt(ts.split('.')[0]);
      ts = ts.split('.')[1];
    }
    if (ts.split(':').length === 4) {
      dd = parseInt(ts.split(':')[0]);
      ts = ts.substring(ts.indexOf(':') + 1, ts.length);
    }

    let parts = ts.split(':');
    parts = parts.reverse();

    const ss = parts.length > 0 && parseInt(parts[0]);
    const mm = parts.length > 1 && parseInt(parts[1]) || 0;
    const hh = parts.length > 2 && parseInt(parts[2]) || 0;

    return 0 <= ss && ss <= 60 &&
           0 <= hh && hh <= 24 &&
           0 <= mm && mm <= 60 &&
           0 <= dd && dd <= 99;
  }
}
